import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const ARTIFACT_INVALID_DATE_LABEL = "—";

/** Deterministic SSR label with an explicit UTC suffix. */
export function formatArtifactUtcCompact(value: string) {
  return `${dayjs.utc(value).format("YYYY-MM-DD HH:mm")} UTC`;
}

/** Full UTC timestamp for native title and pre-hydration tooltips. */
export function formatArtifactUtcFull(value: string) {
  return dayjs.utc(value).format("YYYY-MM-DD HH:mm:ss [UTC]");
}

/** True when the value can be rendered as an ISO datetime attribute. */
export function isArtifactDateValid(
  value: string | null | undefined,
): value is string {
  if (!value) return false;
  return dayjs(value).isValid();
}

/** Map Lingui invalid output and empty input to the artifact em dash convention. */
export function normalizeArtifactDateLabel(
  formatted: string,
  value?: string | null,
) {
  if (!value || formatted === "Invalid date") {
    return ARTIFACT_INVALID_DATE_LABEL;
  }
  return formatted;
}
